import React from 'react';
import PropTypes from 'prop-types';
import { DateTimeInput } from 'src/components/DateTimeInput/DateTimeInput';
import Loading from 'src/components/Loading';
import { DateTime } from 'src_common/utils/time/time';

class ChatNightMode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            messageTemplates: '',
            scheduleStart: DateTime.current().utc().format(),
            scheduleEnd: DateTime.current().utc().format()
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            messageTemplates: props.chatNightMode.get('messageTemplates'),
            scheduleStart: DateTime.from(props.chatNightMode.get('scheduleStart')).utc().format(),
            scheduleEnd: DateTime.from(props.chatNightMode.get('scheduleEnd')).utc().format()
        });
    }

    componentDidMount() {
        this.props.onGetChatNightMode();
    }

    onChange(event) {
        const {
            name,
            value
        } = event.target;

        this.setState({
            [name]: value
        });
    }

    onSubmit() {
        this.props.onSetChatNightModeRequest(this.state);
    }

    render() {
        const { messageTemplates, scheduleStart, scheduleEnd } = this.state;
        const isUpdating = this.props.chatNightMode.get('state') === 'IN_PROGRESS';
        return (
            <div className='chat-content'>
                <h1>Chat Night Mode</h1>
                <div className='input-container'>
                    <label htmlFor='shortDescription'>Night Mode Message:</label>
                    <textarea
                        name='messageTemplates'
                        value={messageTemplates}
                        className='chat-message'
                        id='shortDescription'
                        placeholder='Message'
                        onChange={this.onChange}
                    />
                </div>
                <div className='date-container'>
                    <div className='date-time-container'>
                        <label htmlFor='scheduleStart'>Start Time:</label>
                        <DateTimeInput
                            name='scheduleStart'
                            value={scheduleStart}
                            forceUpdate={true}
                            onChange={(value) => {
                                const parsed = DateTime.from(value);
                                this.onChange({
                                    target: {
                                        value: parsed === null ? '' : parsed.utc().format(),
                                        name: 'scheduleStart'
                                    }
                                });
                            }}
                        />
                    </div>
                    <div className='date-time-container'>
                        <label htmlFor='scheduleEnd'>End Time:</label>
                        <DateTimeInput
                            name='scheduleEnd'
                            value={scheduleEnd}
                            forceUpdate={true}
                            onChange={(value) => {
                                const parsed = DateTime.from(value);
                                this.onChange({
                                    target: {
                                        value: parsed === null ? '' : parsed.utc().format(),
                                        name: 'scheduleEnd'
                                    }
                                });
                            }}
                        />
                    </div>
                </div>
                <a href='#' className='btn btn-apply' onClick={this.onSubmit}>Apply</a>
                <Loading active={isUpdating} message='Updating chat night mode settings...'/>
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default ChatNightMode;
